import { required, requiredIf, email, maxLength, minLength, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default {
  form: {
    fullname: {
      required: helpers.withMessage(i18n.global.t('Please enter a customer name.'), required),
      maxLength: helpers.withMessage(
        ({
          $params,
        }) => i18n.global.t('Customer name cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
        maxLength(255)
      ),
      minLength: helpers.withMessage(
        ({
          $params,
        }) => i18n.global.t('Customer name must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
        minLength(3)
      ),
      pattern: helpers.withMessage(i18n.global.t('Customer names can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
    },
    national_id: {
      required: helpers.withMessage(i18n.global.t('Please enter the national ID card number.'), required),
      pattern: helpers.withMessage(i18n.global.t('National ID must be exactly 13 digits.'), helpers.regex(/^\d{13}$/)),
    },
    customer_group_id: {
      required: helpers.withMessage(i18n.global.t('Please select a customer group.'), required),
    },
    branch_id: {

    },
    email: {
      email: helpers.withMessage(i18n.global.t('Please enter a valid email address.'), email),
      maxLength: helpers.withMessage(
        ({
          $params,
        }) => i18n.global.t('Email cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
        maxLength(100)
      ),
    },
    telephone1: {
      requiredIfTelephone2: helpers.withMessage(
        i18n.global.t('Please enter telephone 1 when telephone 2 is provided.'),
        requiredIf(function () {
          return !!this.form.telephone2;
        })
      ),
      pattern: helpers.withMessage(i18n.global.t('Please enter a valid mobile number.'), helpers.regex(/^0\d{8,9}$/)),
    },
    telephone2: {
      pattern: helpers.withMessage(i18n.global.t('Please enter a valid mobile number.'), helpers.regex(/^0\d{8,9}$/)),
    },
    line_id: {
      maxLength: helpers.withMessage(
        ({
          $params,
        }) => i18n.global.t('Line ID cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
        maxLength(255)
      ),
    },
    address: {},
    sub_district: {},
    district: {},
    province: {},
    postal_code: {}
  }
};
